
import { defineComponent, onMounted, onUnmounted, ref } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { NotifyPopupService, PopupKey } from '@/views/dashboard/_notify-popup/notify-popup.service'
import { IS_PRIVATE } from '@/common/const/env'
import { AuthState } from '@/services/system-auth.service'
import { systemAuthService } from '@/common/basis/root-injector'
import RenewalServiceDrawer from '@/views/dashboard/_components/renewal-service-drawer/renewal-service-drawer.vue'

export default defineComponent({
  components: { RenewalServiceDrawer },

  setup (props, context) {
    const injector = useReflectiveInjector([])
    const notifyPopupService = injector.get(NotifyPopupService)

    const visible = ref(false)
    const isRenewDrawer = ref(false)

    const notifyPopupSubscribe = notifyPopupService.onChangeActiveIndex.subscribe(() => {
      const popupKey = notifyPopupService.activePopupKey
      if (popupKey !== PopupKey.allServicesExpired) {
        return
      }

      if (systemAuthService.authInfo.authorize_state === AuthState.authExpired && IS_PRIVATE) {
        visible.value = true
      } else {
        notifyPopupService.nextPopup()
      }
    })

    onMounted(() => {
      notifyPopupService.popupToReady(PopupKey.allServicesExpired)
    })

    function handleClose () {
      visible.value = false
      notifyPopupService.nextPopup()
    }

    function showDetails () {
      visible.value = false
      isRenewDrawer.value = true
      notifyPopupService.closeAllPopup()
    }

    onUnmounted(() => {
      notifyPopupSubscribe.unsubscribe()
    })

    return {
      visible,
      isRenewDrawer,
      handleClose,
      showDetails,
    }
  }
})
